import React from 'react';
import { useTranslation } from 'react-i18next';

const ExpertiseSectionCyberData: React.FC = () => {
  const { t } = useTranslation();
  
  return (
      <div className="expertise-section">
        <div className="main-text">
          <h3 className="h3-gradient-cyberaudit">
          {t('auditCyber.expertiseSection.mainText', 'Un test d\'intrusion ne se limite pas à identifier les failles techniques, il permet également d\'évaluer la vigilance et les réflexes de vos employés face aux menaces.')}
          </h3>
        </div>
      </div>
    );
};

export default ExpertiseSectionCyberData;
